<template>
  <div class="history-range" role="group" aria-label="播放历史时间范围">
    <component :is="salt ? 'SaltButton' : 'button'" v-for="range in ranges" :key="range.id" type="button" :style-type="value === range.id ? 'subtle' : 'plain'" :class="{ selected: value === range.id }" :aria-pressed="String(value === range.id)" @click="$emit('input', range.id)">{{ range.label }}</component>
    <span v-if="value === 'week' && untimedCount" class="legacy-note">{{ untimedCount }} 首较早记录没有播放时间，保留在“所有时间”中。</span>
  </div>
</template>
<script>
import SaltButton from '../salt/ui/SaltButton.vue';
export default {
  name: 'HistoryRange', components: { SaltButton },
  props: { value: { type: String, default: 'week' }, salt: Boolean, untimedCount: { type: Number, default: 0 } },
  data() { return { ranges: [{ id: 'week', label: '最近一周' }, { id: 'all', label: '所有时间' }] }; },
  mounted() { this.$emit('tick', Date.now()); this._historyClock = window.setInterval(() => this.$emit('tick', Date.now()), 60_000); },
  beforeDestroy() { window.clearInterval(this._historyClock); },
};
</script>
<style scoped>
.history-range { display:flex; align-items:center; flex-wrap:wrap; gap:4px; margin-bottom:16px; }
button:not(.salt-ui-button) { color:var(--color-text); border-radius:8px; padding:6px 8px; opacity:.68; font-weight:500; cursor:pointer; }
button:not(.salt-ui-button):hover, button:not(.salt-ui-button).selected { background:var(--color-secondary-bg); opacity:1; }
button:not(.salt-ui-button).selected { font-weight:700; }
.legacy-note { color:var(--color-secondary); font-size:12px; line-height:1.5; padding:0 8px; }
</style>
